<template>
    <v-container grid-list-md fluid>
        <img class="text-center" alt="Master Meal Planner logo" src="@/assets/logo.png" id="logo" @click="goToPath('/')">
        <h1 class="mmp-title">Master Meal Planner</h1>
        <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css">
        <div style="text-align:center;">
            <a href="https://mastermealplanner.page.link/ios" target="_blank"><img src="https://firebasestorage.googleapis.com/v0/b/master-meal-planner.appspot.com/o/web%2Fmaster-meal-planner-apple-ios-app-store.png?alt=media&token=2cc76697-1ec0-4990-b088-2d23df06231a" style="max-width:300px;" /></a>
        </div>
        <div v-if="!isAuthenticated" class="cta-share text-center pointer">
            <v-btn color="info" large @click="goToPath('/contribute')">Share Recipes</v-btn>
        </div>         
    </v-container>
</template>

<script>
    export default {
        name: "Home",
        props: {
            msg: String
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
        },
        methods: {
            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    #logo {
        margin-top:5px;
        margin-bottom:5px;
        width: 150px;
    }
    .mmp-title {
        text-align:center;
        font-size:40px;
        line-height: 42px;
        font-weight:bold;
        margin:0px 0px 20px 0px;
    }    
    #mc_embed_signup {
        /* background:#fff; */
        clear: left;
        font: 14px Helvetica, Arial, sans-serif;
        width: 80%;
        margin: auto;
    }
    #mc_embed_signup .button {
        background-color: #41d8d5;
        color: #fff;
        height: 40px;
        /* min-width: 150px; */
        font-weight: 400;
        font-size: 18px;
        border: 3px solid #fff;
    }
    .greeting {
        margin: auto;
    }   
</style>
